const createItemSurahTemplate = (surah) => `
  <div onclick="location.assign('#/surah/${surah.id}')"
    class="w-full md:w-1/4 m-3 py-2 px-3 text-center border border-[#0B666A] rounded-md
      cursor-pointer flex flex-col justify-center hover:bg-[#35A29F] hover:text-white hover:duration-300"
  >
    <h3 tabindex="0">${surah.number}. ${surah.name} (${surah.translation})</h3>
    <p tabindex="0">${surah.revelation} - ${surah.numberOfAyahs} Ayat</p>
  </div>
`;

const createSurahSummaryTemplate = (surah) => `
  <div class="section-title-container">
    <h2 class="section-title" tabindex="0">${surah.name} (${surah.translation})</h2>
    <p class="section-subtitle" tabindex="0">${surah.revelation} - ${surah.numberOfAyahs} Ayat</p>
    <p id="desc-surah" class="text-center mt-2" tabindex="0">${surah.description.slice(0, 140)}</p>
    <button id="btn-desc-surah" class="block mx-auto text-[#35A29F]">Selengkapnya...</button>
  </div>
  <div id="bismillah-container" class="text-center w-fit mx-auto my-4 py-3 md:px-10 border-y border-[#35A29F]">
    <p tabindex="0" class="text-arabic text-3xl pb-2">${surah.bismillah.arab}</p>
    <p tabindex="0">${surah.bismillah.translation}</p>
  </div>
  <div class="flex justify-between items-center">
    <button class="animate-pulse w-14" title="Pergi ke Halaman Favorite" onclick="location.assign('#/favorite');">
      <img src="./icons/heart-fill-icon.svg" alt="favorite icon">
    </button>
    <form id="form-search-ayah" class="flex justify-between items-center ms-3">
      <input type="number" min="1" max="${surah.numberOfAyahs}" placeholder="1 - ${surah.numberOfAyahs}" id="input-num-ayah" class="w-full focus:outline-[#35A29F] py-1 rounded-md text-center text-black md:text-lg border-b border-[#35A29F]" required/>
      <button type="submit" class="animate-pulse w-32" title="Cari Ayat">
        <img src="./icons/search-sort-icon.svg" alt="search icon">
      </button>
    </form>
    <button id="btn-to-bookmark" class="animate-pulse w-14" title="Pergi ke Terakhir Dibaca">
      <img src="./icons/bookmark-fill-icon.svg" alt="bookmark icon">
    </button>
  </div>
  <div class="fixed bottom-2 left-2 right-2 md:px-2 z-50">
    <c-audio-player data-audio="${surah.audio}"></c-audio-player>
  </div>
`;

const createAyahTemplate = (surah) => `
  <div id="ayah-${surah.number.inSurah}" class="my-4 py-3 px-1.5 md:px-3 border-y border-[#35A29F] rounded-xl hover:shadow-lg">
    <div>
      <p class="text-arabic text-end text-2xl mb-2" tabindex="0">
        ${surah.arab}
        <span id="arabic-number" class="text-[#35A29F] me-2">
          (${String(surah.ayahNumber).replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d])})
        </span>
      </p>
      <p tabindex="0">
        <span id="ayah-number">${surah.ayahNumber}</span>. ${surah.translation}
      </p>
    </div>
    <div>
      <div id="ayah-tools" class="flex items-center">
        <button
          id="btn-tafsir-ayah"
          numAyahQuran="${surah.number.inQuran}"
          numAyahSurah="${surah.number.inSurah}"
          class="me-auto text-[#35A29F] border-[#35A29F] rounded-xl"
        >Tafsir</button>
        <div class="relative inline-block">
          <span id="tooltip-favorite-ayah-${surah.number.inQuran}" class="tooltip-tool invisible">Tersimpan</span>
          <button
            id="btn-favorite-ayah"
            numAyahQuran="${surah.number.inQuran}"
            numAyahSurah="${surah.number.inSurah}"
            ayahNumber="${surah.ayahNumber}"
            surahNumber="${surah.surahNumber}"
            surahName="${surah.surahName}"
            surahTranslation="${surah.surahTranslation}"
            surahRevelation="${surah.surahRevelation}"
            class="w-12" title="Simpan Ayat"
          >
            <img src="./icons/heart-outline-icon.svg" alt="favorite icon">
          </button>
        </div>
        <div class="relative inline-block">
          <span id="tooltip-bookmark-ayah-${surah.number.inQuran}" class="tooltip-tool invisible">Terakhir dibaca</span>
          <input type="radio" id="bookmark-ayah-${surah.number.inQuran}" class="hidden" name="bookmark-ayah"/>
          <button
            id="btn-bookmark-ayah"
            numAyahQuran="${surah.number.inQuran}"
            numAyahSurah="${surah.number.inSurah}"
            ayahNumber="${surah.ayahNumber}"
            surahNumber="${surah.surahNumber}"
            surahName="${surah.surahName}"
            class="block w-12" title="Tandai Terakhir Dibaca"
          >
            <label for="bookmark-ayah-${surah.number.inQuran}" class="cursor-pointer">
              <img src="./icons/bookmark-outline-icon.svg" alt="bookmark icon">
            </label>
            <label for="bookmark-ayah-${surah.number.inQuran}" class="hidden unsave-icon cursor-pointer">
              <img src="./icons/bookmark-fill-icon.svg" alt="unbookmark icon">
            </label>
          </button>
        </div>
        <button
          id="btn-copy-ayah"
          numAyahQuran="${surah.number.inQuran}"
          numAyahSurah="${surah.number.inSurah}"
          ayahNumber="${surah.ayahNumber}"
          surahNumber="${surah.surahNumber}"
          surahName="${surah.surahName}"
          class="relative inline-block w-12" title="Salin Ayat"
        >
          <span id="tooltip-copy-ayah-${surah.number.inQuran}" class="tooltip-tool invisible">Berhasil disalin</span>
          <img src="./icons/copy-icon.svg" alt="copy icon">
        </button>
        <button
          id="btn-play-ayah"
          numAyahQuran="${surah.number.inQuran}"
          numAyahSurah="${surah.number.inSurah}"
          class="w-12 border-[#35A29F] rounded-full" title="Dengarkan Ayat"
        >
          <img src="./icons/play-icon.svg" alt="play icon">
        </button>
      </div>
      <div id="play-list-${surah.number.inQuran}" class="hidden my-3 border-t border-[#97FEED]"></div>
      <div id="tafsir-${surah.number.inQuran}" class="hidden my-3 border-t border-[#97FEED]"></div>
    </div>
  </div>
`;

const createTafsirAyahTemplate = (srcTafsir, tafsir) => `
  <details class="my-3">
    <summary class="pb-2 cursor-pointer marker:text-[#35A29F]" tabindex="0">${srcTafsir}</summary>
    <p tabindex="0">${tafsir}</p>
  </details>
`;

const createPlayListAyahTemplate = (reader, audio) => `
  <details class="my-3">
    <summary class="pb-2 cursor-pointer marker:text-[#35A29F]" tabindex="0">${reader}</summary>
    <c-audio-player data-audio="${audio}"></c-audio-player>
  </details>
`;

const createBookmarkItemTemplate = (bookmark) => `
  <div class="flex items-center mb-2 border-b py-4 md:justify-center">
    <img src="./icons/bookmark-outline-icon.svg" alt="bookmark icon" class="w-7 me-2" tabindex="0">
    <a id="bookmark-item" href="#/surah/${bookmark.surahNumber}" class="text-lg font-bold">
      Bookmark (Q.S ${bookmark.surahName} ${bookmark.surahNumber}:${bookmark.ayahNumber})
    </a>
  </div>
`;

const createContentEmptyTemplate = () => `
  <div class="content-empty">
    <video class="content-empty__gif" aria-label="data is empty" autoplay loop muted playsinline tabindex="0">
      <source src="./images/empty-animation.webm" type="video/webm">
      <source src="./images/empty-animation.mp4" type="video/mp4">
    </video>
    <p class="content-empty__text text-content" tabindex="0">Halaman ini kosong!</p>
  </div>
`;

const createContentFailedTemplate = () => `
  <div class="content-empty">
    <video class="content-empty__gif" aria-label="data is empty" autoplay loop muted playsinline tabindex="0">
      <source src="./images/failed-animation.webm" type="video/webm">
      <source src="./images/failed-animation.mp4" type="video/mp4">
    </video>
    <p class="content-empty__text text-content" tabindex="0">Terjadi kesalahan. Gagal mengambil data!</p>
  </div>
`;

const createLoadingTemplate = () => `
  <div class="loading-gif-container">
    <video class="loading-gif rounded-full" aria-label="data is loading" autoplay loop muted playsinline tabindex="0">
      <source src="./images/loading-animation.webm" type="video/webm">
      <source src="./images/loading-animation.mp4" type="video/mp4">
    </video>
  </div>
`;

export {
  createItemSurahTemplate,
  createSurahSummaryTemplate,
  createAyahTemplate,
  createTafsirAyahTemplate,
  createPlayListAyahTemplate,
  createBookmarkItemTemplate,
  createContentEmptyTemplate,
  createContentFailedTemplate,
  createLoadingTemplate,
};
